export default {
  // Linear / Non Linear mode
  linearMode: false,

  // Display an introduction page at start
  introductionPage: true,

  // Score needed to pass the test
  scoreToPass: 9,
}
